module.exports = __webpack_public_path__ + "static/media/cropped-Artificial-intelligence-logo.888f9845.png";